import QuizQuestionService from 'src/modules/quizQuestion/quizQuestionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'QUIZ_QUESTION_VIEW';

const quizQuestionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionViewActions.FIND_STARTED,
      });

      const record = await QuizQuestionService.find(id);
      
      dispatch({
        type: quizQuestionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizQuestionViewActions.FIND_ERROR,
      });

      getHistory().push('/quiz-question');
    }
  },
};

export default quizQuestionViewActions;
